const React = require('react');
const isNode = (typeof process !== 'undefined');

class EmployeeList extends React.Component {
    render() {
        const { departments, title } = this.props;

        return (
        <section className="employees">
            <div className="employees__container">
                {title && <h2 className="employees__title">{title}</h2>}
                <ul className="employees__department-list">
                    {departments.map((department, i) => {
                        return (
                        <li key={i}>
                            <a href={`#${department._name}`}>
                                {department.displayName}
                            </a>
                        </li>
                        )
                    })}
                </ul>

                {departments.map((department, i) => {
                    return (
                    <div key={i} id={department._name}>
                        <h2 className="employees__department-title">{department.displayName}</h2>
                        <div className="employees__department">
                            {department.employees.map((employee, j) => {
                                return (
                                <div className="employees__wrapper" key={`${i}-${j}`}>
                                    <div className="employees__employee">
                                        <img src={employee.data.image} className="employees__image"/>
                                        <h3 className="employees__name">{employee.data.name}</h3>

                                        {employee.data.position && (
                                        <h4 className="employees__position">{employee.data.position}</h4>
                                        )}

                                        {employee.data.email && (
                                        <a className="employees__email" href={`mailto:${employee.data.email}`}>
                                            {employee.data.email}
                                        </a>
                                        )}

                                        {employee.data.phone && (
                                        <a className="employees__phone" href={`tel:${employee.data.phone}`}>
                                            {employee.data.phone}
                                        </a>
                                        )}
                                    </div>
                                </div>
                                )
                            })}
                        </div>
                    </div>
                    )
                })}

            </div>
        </section>
        )
    }
}

module.exports = EmployeeList;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/employee-list/Component/index.jsx